import { Component } from '@angular/core';

@Component({
  templateUrl: './dl-home.component.html',
})
export class DLHomeComponent {
  
}